const concatStrings = (delimiter = '', args: string[]) => {
  return args.join(delimiter)
}

export { concatStrings }
